const EventEmitter = require('eventemitter3');

const _defineCurrentEventId = state => {
    const s = state.replace('event-cover-', 'event-');
    return s.match(/event-\d+/) ? s : '';
};

const _defineCurrentEventIndex = state => {
    const s = state.replace('event-cover-', 'event-');
    return s.match(/event-\d+/) ? parseInt(s.substr(6)) : -1;
};

const _isEventCoverState = state => state.match(/event-cover-\d+/);

const _isEventState = state => state.match(/event-\d+/);

const _isEventLocationState = state => state.match(/event-/);

class _CoreModel extends EventEmitter {
    constructor() {
        super();

        // States:
        // loading
        // ready
        // fatal
        this._status = 'loading';
        this._statusChanged = false;

        // States:
        // loader
        // app-cover
        // event-cover-0-11
        // event-0-11
        this._state = 'loader';
        this._prevState = '';
        this._firstState = '';
        this._lastState = '';
        this._stateChanged = false;
        this._isFirstState = false;
        this._isLastState = false;
        this._prevIsFirstState = false;
        this._prevIsLastState = false;
        this._isFirstUserAction = true;

        // TO TEST IN DEV
        this._swipeInProgressEnabled = false;

        this._currentEventId = _defineCurrentEventId(this._state);
        this._currentEventIndex = _defineCurrentEventIndex(this._state);
        this._currentCoverOpened = false;
        this._currentCoverOpenedChanged = false;
        this._currentEventOpened = false;
        this._currentEventOpenedChanged = false;
        this._currentEventExpanded = false;
        this._currentEventExpandedChanged = false;

        // Menu:
        this._menuOn = false;
        this._menuOnChanged = false;
        this._menuAvailable = true;
        this._menuAvailableChanged = false;

        // Sound
        // On/Off state is to be set according to browser Autoplay abilities
        this._soundOn = true;
        this._soundOnChanged = false;
        this._soundChannelState = 'default';
        this._soundChannelStateChanged = false;

        this._transition3dInProgress = false;
    }
    get status() {
        return this._status;
    }
    set status(value) {
        if (value === this._status) return this._status;
        this._status = value;
        this._statusChanged = true;
        return this._status;
    }
    get statusChanged() {
        return this._statusChanged;
    }
    resetStatusChanged() {
        this._statusChanged = false;
    }
    get menuAvailable() {
        return this._menuAvailable;
    }
    set menuAvailable(value) {
        if (value === this._menuAvailable) return this._menuAvailable;
        this._menuAvailable = value;
        this._menuAvailableChanged = true;

        return this._menuAvailable;
    }
    get menuAvailableChanged() {
        return this._menuAvailableChanged;
    }
    resetMenuAvailableChanged() {
        this._menuAvailableChanged = false;
    }
    get menuOn() {
        return this._menuOn;
    }
    set menuOn(value) {
        if (value === this._menuOn) return this._menuOn;
        this._menuOn = value;
        this._menuOnChanged = true;

        // FLAG SOUND CHANGING
        if (this._menuOn) {
            this._soundChannelState = 'menu';
            this._soundChannelStateChanged = true;
        }

        return this._menuOn;
    }
    get menuOnChanged() {
        return this._menuOnChanged;
    }
    resetMenuOnChanged() {
        this._menuOnChanged = false;
    }
    get soundOn() {
        return this._soundOn;
    }
    set soundOn(value) {
        if (value === this._soundOn) return this._soundOn;
        this._soundOn = value;
        this._soundOnChanged = true;
        return this._soundOn;
    }
    get soundOnChanged() {
        return this._soundOnChanged;
    }
    resetSoundOnChanged() {
        this._soundOnChanged = false;
    }
    get soundChannelState() {
        return this._soundChannelState;
    }
    get soundChannelStateChanged() {
        return this._soundChannelStateChanged;
    }
    resetSoundChannelStateChanged() {
        this._soundChannelStateChanged = false;
    }
    get prevState() {
        return this._prevState;
    }
    get state() {
        return this._state;
    }
    get isEventState() {
        return _isEventState(this._state);
    }
    set state(value) {
        if (value === this._state) return this._state;

        this._prevState = this._state;
        this._prevIsFirstState = this._isFirstState;
        this._prevIsLastState = this._isLastState;

        let newState = value;
        let newCurrentEventIndex = _defineCurrentEventIndex(value);
        const prevCurrentEventIndex = _defineCurrentEventIndex(this._prevState);

        // 1: Going BACKWARD to an Event Cover
        if (_isEventCoverState(newState) && newCurrentEventIndex === prevCurrentEventIndex) {
            //
            // Do skip the previous event cover slide:
            newCurrentEventIndex -= 1;
            newState = newCurrentEventIndex < 0 ? 'app-cover' : `event-${newCurrentEventIndex}`;
        }

        // 2. Update Current Event State
        //
        // 2.1: Reset when Going any other state then an Event
        let currentEventOpened = false;

        //
        // 2.2: Open IF Going FORWARD to an Event State
        if (_isEventState(newState)) {
            currentEventOpened = newCurrentEventIndex === prevCurrentEventIndex;
        }

        this._currentEventOpenedChanged = this._currentEventOpened !== currentEventOpened;
        this._currentEventOpened = currentEventOpened;

        // 2.3. Hide cover If Going to another Event
        if (_isEventLocationState(newState) && newCurrentEventIndex !== prevCurrentEventIndex) {
            this._currentCoverOpenedChanged = this._currentCoverOpened;
            this._currentCoverOpened = false;
        }

        this._transitionEvtInProgress =
            (this._currentCoverOpened && this._currentCoverOpenedChanged) || (this._currentEventOpened && this._currentEventOpenedChanged);

        this._currentEventExpanded = false;
        this._currentEventExpandedChanged = false;

        // Set State
        this._state = newState;
        this._needTransition = newCurrentEventIndex !== prevCurrentEventIndex;
        this._needCompleteTransition = !this._menuOn;
        this._currentEventId = newCurrentEventIndex > -1 ? `event-${newCurrentEventIndex}` : '';
        this._currentEventIndex = newCurrentEventIndex;
        this._isFirstState = this._state === this._firstState;
        this._isLastState = this._state === this._lastState;

        // this._autoplayMode = _isEventState(this._state) && this._currentCoverOpened;

        // 3. Sound update
        if (this._currentEventOpened) {
            this._soundChannelState = this._state;
            this._soundChannelStateChanged = true;
        }

        this._stateChanged = true;

        return this._state;
    }
    get stateChanged() {
        return this._stateChanged;
    }
    configStates(obj) {
        this._states = obj.states;
        this._firstState = obj.states[0] || 'app-cover';
        this._lastState = obj.states[obj.states.length - 1] || '';
    }
    resetStateChanged() {
        this._stateChanged = false;
    }
    get isFirstState() {
        return this._isFirstState;
    }
    get isLastState() {
        return this._isLastState;
    }
    get previousIsFirstState() {
        return this._prevIsFirstState;
    }
    get previousIsLastState() {
        return this._prevIsLastState;
    }
    get currentEventId() {
        return this._currentEventId;
    }
    get currentEventIndex() {
        return this._currentEventIndex;
    }
    set currentCoverOpened(value) {
        if (value === this._currentCoverOpened) return this._currentCoverOpened;

        if (this._currentEventIndex === 0 && !this._helperDone) {
            this.helperOpen = true;
            this._helperDone = true;

            return this._currentCoverOpened;
        }

        this._currentCoverOpened = value;
        this._currentCoverOpenedChanged = true;

        /* if (this._currentCoverOpenedChanged) {
            this._soundChannelState = this._state;
            this._soundChannelStateChanged = true;
        }*/

        return this._currentCoverOpened;
    }
    get currentCoverOpened() {
        return this._currentCoverOpened;
    }
    get currentCoverOpenedChanged() {
        return this._currentCoverOpenedChanged;
    }
    resetCurrentCoverOpenedChanged() {
        this._currentCoverOpenedChanged = false;
    }
    get helperOpen() {
        return this._helperOpen;
    }
    set helperOpen(value) {
        if (value === this._helperOpen) return this._helperOpen;
        this._helperOpen = value;
        this._helperOpenChanged = true;

        this._menuAvailable = !this._helperOpen;
        this._menuAvailableChanged = true;

        if (this._helperOpen) {
            this._menuOn = false;
            this._menuOnChanged = true;
        }

        return this._helperOpen;
    }
    get helperOpenChanged() {
        return this._helperOpenChanged;
    }
    resetHelperOpenChanged() {
        this._helperOpenChanged = false;
    }
    set currentEventOpened(value) {
        if (value === this._currentEventOpened) return this._currentEventOpened;
        this._currentEventOpened = value;
        this._currentEventOpenedChanged = true;

        this._currentEventExpandedChanged = this._currentEventExpanded;
        this._currentEventExpanded = false;

        if (this._currentEventOpened) {
            this._soundChannelState = this._state;
            this._soundChannelStateChanged = true;
        }

        return this._currentEventOpened;
    }
    get currentEventOpened() {
        return this._currentEventOpened;
    }
    get currentEventOpenedChanged() {
        return this._currentEventOpenedChanged;
    }
    resetCurrentEventOpenedChanged() {
        this._currentEventOpenedChanged = false;
    }
    set currentEventExpanded(value) {
        if (value === this._currentEventExpanded) return this._currentEventExpanded;
        this._currentEventExpanded = value;
        this._currentEventExpandedChanged = true;

        return this._currentEventExpanded;
    }
    get currentEventExpanded() {
        return this._currentEventExpanded;
    }
    get currentEventExpandedChanged() {
        return this._currentEventExpandedChanged;
    }
    resetCurrentEventExpandedChanged() {
        this._currentEventExpandedChanged = false;
    }
    get allowGetPrevState() {
        // Prevent going to the last month from the app cover
        // and prevent moving while any event is opened
        return this.navAllowed && this._state !== 'app-cover';
    }
    get allowGetNextState() {
        // Prevent moving while any event is opened
        return this.navAllowed;
    }
    get needTransition() {
        return this._needTransition;
    }
    get needCompleteTransition() {
        return this._needCompleteTransition;
    }
    get transition3dInProgress() {
        return this._transition3dInProgress && this._state !== 'app-cover';
    }
    set transition3dInProgress(value) {
        this._transition3dInProgress = value;
        return this._transition3dInProgress;
    }
    get transition3dState() {
        return this._transition3dState;
    }
    set transition3dState(value) {
        if (value === this._transition3dState) return this._transition3dState;
        this._transition3dState = value;

        const state = 'event-cover-' + this._transition3dState;
        if (state !== this._soundChannelState) {
            this._soundChannelState = state;
            this._soundChannelStateChanged = true;
        }

        return this._transition3dState;
    }
    get transitionEvtInProgress() {
        return this._transitionEvtInProgress;
    }
    set transitionEvtInProgress(value) {
        this._transitionEvtInProgress = value;
        return this._transitionEvtInProgress;
    }
    get transitionInProgress() {
        return this._transitionEvtInProgress || this.transition3dInProgress;
    }
    get navAllowed() {
        return (
            this._status === 'ready' && !this._currentEventOpened && !this._currentEventExpanded && (this._swipeInProgressEnabled || !this.transitionInProgress)
        );
    }
    setPackIsReady(key) {
        this._packsLoaded = this._packsLoaded || {};
        this._packsLoaded[key] = true;
    }
    isPackReady(key) {
        return this._packsLoaded ? this._packsLoaded[key] : false;
    }
    doFirstUserAction() {
        // Listen to mousedown once in order to enable audio
        if (this._isFirstUserAction) {
            this._soundOn = true;
            this._soundOnChanged = true;
            this._isFirstUserAction = false;
        }
    }
}

let _instance;
const CoreModel = {};

// Singleton: CoreModel

CoreModel.instance = () => {
    if (_instance) return _instance;
    _instance = new _CoreModel();
    return _instance;
};

CoreModel.destroy = () => {
    const instance = _instance;
    _instance = undefined;
    return instance;
};

export default CoreModel;
export {CoreModel};
